import { render } from "./User.vue?vue&type=template&id=2f5d3414&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=2f5d3414&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f5d3414"

export default script